import { z } from 'zod';
/**
 * Was ein Abgleich mit dem CRM zu berichten hat.
 *
 * Ein Knopf, der wortlos nichts tut, sieht aus wie ein kaputter Knopf. Wer
 * ihn drückt, zweifelt gerade am Stand und will eine Antwort — auch wenn sie
 * „nichts Neues" lautet.
 */ export const RefreshAccountCrmResponseSchema = z.object({
    /**
   * Ob überhaupt gelesen wurde. `false` heißt: keine verknüpfte Firma, oder
   * das CRM hat nicht geantwortet — etwas anderes als „nichts Neues".
   */ read: z.boolean(),
    /** Ob sich am Konto etwas geändert hat. */ changed: z.boolean(),
    /** Welche Felder das CRM geliefert hat — für den Satz „was kam". */ fields: z.array(z.string()),
    /**
   * Rollen, in denen im CRM **mehr als ein** Kontakt steht.
   *
   * HubSpot lässt ein Assoziations-Etikett beliebig oft vergeben; wir nehmen
   * den ersten, und welcher das ist, entscheidet HubSpots Reihenfolge. Eine
   * Angebotsmail geht an eine Adresse — wer nachsieht, soll erfahren, dass
   * hier gerade der Zufall entscheidet.
   */ ambiguousRoles: z.array(z.enum([
        'primary',
        'billing'
    ]))
});

//# sourceMappingURL=refresh-account-crm.schema.js.map